import { render } from "./Moderacao.vue?vue&type=template&id=39543bcd&scoped=true"
import script from "./Moderacao.vue?vue&type=script&lang=js"
export * from "./Moderacao.vue?vue&type=script&lang=js"

import "./Moderacao.vue?vue&type=style&index=0&id=39543bcd&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39543bcd"]])

export default __exports__